'use client';

export function MSWProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
} 